import './Order.css';

function Order() {
  return (
    <div className='form'>
      <iframe
        title="Order Form"
        className="order-form"
        src="https://docs.google.com/forms/d/e/1FAIpQLScmwuFPMUcFOiWFJptPez3jZmV44Cw6AFKtb9pXwHUQfLr0ng/viewform?embedded=true"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
}

export default Order;
